(function () {
  function pickRandom(list) {
    return list[Math.floor(Math.random() * list.length)];
  }

  function initRandomImage(element) {
    const target = element.querySelector('[data-statement-images]');
    if (!target) {
      return;
    }
    const images = (target.dataset.statementImages || '')
      .split('|')
      .map((url) => url.trim())
      .filter(Boolean);

    if (images.length === 0) {
      console.warn('Statement: Keine Bilder vorhanden');
      return;
    }
    target.style.backgroundImage = `url("${pickRandom(images)}")`;
  }

  function initRandomText(element) {
    const variants = Array.from(element.querySelectorAll('[data-statement-variant]'));
    if (variants.length < 2) {
      return;
    }
    const chosen = pickRandom(variants);
    variants.forEach((variant) => {
      variant.hidden = variant !== chosen;
    });
  }

  function init() {
    document.querySelectorAll('[data-statement]').forEach((element) => {
      initRandomImage(element);
      initRandomText(element);
      element.classList.add('statement--ready');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
